import { Component, Input, OnInit} from '@angular/core';
import {CommentBdc, CommentService, Evaluation, EvaluationService, Page} from '../../common/services';
import {catchError} from 'rxjs/operators';
import {Observable, of, throwError} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {PubSubService} from '../../common/services/pub-sub.service';
import {typeEvents} from '../../common/enum/type-events';

@Component({
  selector: 'p8-bdc-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {
  @Input()
  set page(value: Page) {
    // console.log('set page ', value);
    this._page = value;

    this.setEvalAndComment();
  }

  get page() {
    return this._page;
  }

  _page: Page = null;

  evaluation: Evaluation = <Evaluation>{ id: 0 };
  comment: CommentBdc = <CommentBdc>{ id: 0 };
  commentText = '';

  note = 0;
  disabled = false;

  private user: any = null;

  constructor(private pubsubService: PubSubService,
              private evalSvc: EvaluationService,
              private commSvc: CommentService) {
    this.user = JSON.parse(localStorage.getItem('user'));
  }

  ngOnInit() {

  }

  setEvalAndComment() {
    if (this.user && this.page) {

      this.evalSvc.getByPageAndUser(this.page.id, this.user.id)
        .pipe(catchError((err: HttpErrorResponse ) => {
          if (err.status === 404) {
            return of(null);
          }
          return throwError(err.error || `Server error : ${err} ${JSON.stringify(err)}`);
        }))
        .subscribe((evaluation: Evaluation) => {
          this.note = 0;

          if (evaluation) {
            console.log('eval ', evaluation);
            this.evaluation = evaluation;
            this.note = evaluation.note;
          }
      });
    }

    this.commSvc.getByPageAndUser(this.page.id, this.user.id)
      .pipe(catchError((err: HttpErrorResponse ) => {
        if (err.status === 404) {
          return of(null);
        }
        return throwError(err.error || `Server error : ${err} ${JSON.stringify(err)}`);
      }))
      .subscribe((com: CommentBdc) => {
        if (com) {
          this.comment = com;
          this.commentText = com.text;
        }
      });
  }

  saveComment() {
    if (this.commentText) {
      this.comment.text = this.commentText;
      this.comment.page = this.page.id;
      this.comment.user = this.user.id;

      this.commSvc.updateOrCreate(this.comment).subscribe((c: CommentBdc) => {
        this.comment = c;
        this.pubsubService.publish(typeEvents.commentSaved, 'Merci de votre commentaire, il a bien été enregistré');
      });
    }
  }

  saveNote(note) {
    if (this.user) {
      this.note = note;

      this.evaluation.note = note;
      this.evaluation.user = this.user.id;
      this.evaluation.page = this.page.id;

      console.log('eval click ', this.evaluation);
      this.evalSvc.updateOrCreate(this.evaluation).subscribe((e: Evaluation) => {
        this.evaluation = e;
        this.pubsubService.publish(typeEvents.likeSaved, 'Merci de votre avis, il a bien été enregistré');
      });
    }
  }
}
